var React = require('react');

function IconSocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-linkedin-in","data-name":"Icon awesome-linkedin-in","d":"M4.841,21.628H.357V7.188H4.841ZM2.6,5.219A2.609,2.609,0,1,1,5.194,2.6,2.619,2.619,0,0,1,2.6,5.219Zm19.027,16.41H17.149V14.6c0-1.675-.034-3.824-2.331-3.824-2.331,0-2.689,1.82-2.689,3.7v7.15H7.65V7.188h4.3v1.97h.063a4.712,4.712,0,0,1,4.243-2.332c4.538,0,5.372,2.988,5.372,6.87v7.932Z","transform":"translate(0 0)","fill":"#fff"}));
}

IconSocialLinkedin.defaultProps = {"width":"21.628","height":"21.628","viewBox":"0 0 21.628 21.628"};

module.exports = IconSocialLinkedin;

IconSocialLinkedin.default = IconSocialLinkedin;
